var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48874 13.2812C5.90089 13.2812 3.2463 11.7835 1.1565 8.78787C1.09685 8.70143 1.06416 8.59924 1.06256 8.49422C1.06097 8.3892 1.09053 8.28607 1.14753 8.19785C2.75323 5.68437 5.3723 3.71875 8.48874 3.71875C11.5713 3.71875 14.2442 5.69035 15.8529 8.20947C15.9085 8.29596 15.9381 8.39665 15.9381 8.4995C15.9381 8.60236 15.9085 8.70304 15.8529 8.78953C14.2405 11.2798 11.5481 13.2812 8.48874 13.2812Z",
    stroke: "#95A3CC",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.84375C9.96701 5.84375 11.1562 7.03299 11.1562 8.5C11.1562 9.96701 9.96701 11.1562 8.5 11.1562C7.03299 11.1562 5.84375 9.96701 5.84375 8.5C5.84375 7.03299 7.03299 5.84375 8.5 5.84375Z",
    stroke: "#95A3CC",
    strokeWidth: 1.0625,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDg4NzQgMTMuMjgxMkM1LjkwMDg5IDEzLjI4MTIgMy4yNDYzIDExLjc4MzUgMS4xNTY1IDguNzg3ODdDMS4wOTY4NSA4LjcwMTQzIDEuMDY0MTYgOC41OTkyNCAxLjA2MjU2IDguNDk0MjJDMS4wNjA5NyA4LjM4OTIgMS4wOTA1MyA4LjI4NjA3IDEuMTQ3NTMgOC4xOTc4NUMyLjc1MzIzIDUuNjg0MzcgNS4zNzIzIDMuNzE4NzUgOC40ODg3NCAzLjcxODc1QzExLjU3MTMgMy43MTg3NSAxNC4yNDQyIDUuNjkwMzUgMTUuODUyOSA4LjIwOTQ3QzE1LjkwODUgOC4yOTU5NiAxNS45MzgxIDguMzk2NjUgMTUuOTM4MSA4LjQ5OTVDMTUuOTM4MSA4LjYwMjM2IDE1LjkwODUgOC43MDMwNCAxNS44NTI5IDguNzg5NTNDMTQuMjQwNSAxMS4yNzk4IDExLjU0ODEgMTMuMjgxMiA4LjQ4ODc0IDEzLjI4MTJaIiBzdHJva2U9IiM5NUEzQ0MiIHN0cm9rZS13aWR0aD0iMS4wNjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguNSA1Ljg0Mzc1QzkuOTY3MDEgNS44NDM3NSAxMS4xNTYyIDcuMDMyOTkgMTEuMTU2MiA4LjVDMTEuMTU2MiA5Ljk2NzAxIDkuOTY3MDEgMTEuMTU2MiA4LjUgMTEuMTU2MkM3LjAzMjk5IDExLjE1NjIgNS44NDM3NSA5Ljk2NzAxIDUuODQzNzUgOC41QzUuODQzNzUgNy4wMzI5OSA3LjAzMjk5IDUuODQzNzUgOC41IDUuODQzNzVaIiBzdHJva2U9IiM5NUEzQ0MiIHN0cm9rZS13aWR0aD0iMS4wNjI1IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };